import { useMutation, UseMutationOptions } from 'react-query';

import { authApi } from 'src/Services/API';
import { RequestPasswordResetDto, SuccessResponseDto } from 'src/Services/API/generated';
import { trackEvent } from 'src/Services/Matomo';

export const useRequestResetPassword = (
  options?: UseMutationOptions<SuccessResponseDto, unknown, RequestPasswordResetDto>
) => {
  return useMutation<SuccessResponseDto, unknown, RequestPasswordResetDto>(
    'request-reset-password',
    async data => {
      const response = await authApi.authControllerCreatePasswordResetRequest(data);
      return response.data;
    },
    {
      ...options,
      onSuccess: (data, variables, context) => {
        trackEvent('Auth', 'requestPasswordReset', variables.email);
        options?.onSuccess?.(data, variables, context);
      },
    }
  );
};
